module.exports = __webpack_public_path__ + "img/icon_close.85303327.png";